import * as stylex from '@stylexjs/stylex';
import type { VarGroup } from '@stylexjs/stylex/lib/StyleXTypes';
export type TAnatomy = Readonly<{
  'size-2': string;
  'size-4': string;
  'size-6': string;
  'size-8': string;
  'size-12': string;
  'size-16': string;
  'size-20': string;
  'size-24': string;
  'size-28': string;
  'size-32': string;
  'size-36': string;
  'size-40': string;
  'size-44': string;
  'size-48': string;
  'size-52': string;
  'size-56': string;
  'size-64': string;
  'size-72': string;
  'size-80': string;
  'size-96': string;
  'size-112': string;
  'size-128': string;
  sizeNull: string;
  'space-2': string;
  'space-4': string;
  'space-6': string;
  'space-8': string;
  'space-10': string;
  'space-12': string;
  'space-16': string;
  'space-20': string;
  'space-24': string;
  'space-28': string;
  'space-32': string;
  'space-36': string;
  'space-40': string;
  'space-44': string;
  'space-48': string;
  'space-52': string;
  'space-56': string;
  'space-64': string;
  'space-72': string;
  'space-80': string;
  'space-96': string;
  'space-112': string;
  'space-128': string;
  spaceNo: string;
  borderRadiusNo: string;
  borderRadiusXs: string;
  borderRadiusS: string;
  borderRadiusM: string;
  borderRadiusL: string;
  borderRadiusXl: string;
  borderRadiusXxl: string;
  borderRadiusRound: string;
  borderWidthLight: string;
  borderWidthBold: string;
}>;
export const anatomy: VarGroup<TAnatomy> = stylex.defineVars({
  'size-2': '2px',
  'size-4': '4px',
  'size-6': '6px',
  'size-8': '8px',
  'size-12': '12px',
  'size-16': '16px',
  'size-20': '20px',
  'size-24': '24px',
  'size-28': '28px',
  'size-32': '32px',
  'size-36': '36px',
  'size-40': '40px',
  'size-44': '44px',
  'size-48': '48px',
  'size-52': '52px',
  'size-56': '56px',
  'size-64': '64px',
  'size-72': '72px',
  'size-80': '80px',
  'size-96': '96px',
  'size-112': '112px',
  'size-128': '128px',
  sizeNull: '0px',
  'space-2': '2px',
  'space-4': '4px',
  'space-6': '6px',
  'space-8': '8px',
  'space-10': '10px',
  'space-12': '12px',
  'space-16': '16px',
  'space-20': '20px',
  'space-24': '24px',
  'space-28': '28px',
  'space-32': '32px',
  'space-36': '36px',
  'space-40': '40px',
  'space-44': '44px',
  'space-48': '48px',
  'space-52': '52px',
  'space-56': '56px',
  'space-64': '64px',
  'space-72': '72px',
  'space-80': '80px',
  'space-96': '96px',
  'space-112': '112px',
  'space-128': '128px',
  spaceNo: '{size.null}',
  borderRadiusNo: '{size.null}',
  borderRadiusXs: '4px',
  borderRadiusS: '8px',
  borderRadiusM: '12px',
  borderRadiusL: '16px',
  borderRadiusXl: '24px',
  borderRadiusXxl: '36px',
  borderRadiusRound: '9999px',
  borderWidthLight: '1px',
  borderWidthBold: '4px',
});
